import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
} from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API

class GXPService {
  // HOTEL FEATURES RELATED APIs

  // Get Hotel Directory Menu page
  getFeature() {
    return axios
      .get(API_URL + "gxp/hd-app-feature", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update Hotel Directory Menu page
  UpdateFeature(menu_id, data) {
    return axios
      .patch(API_URL + "gxp/hd-app-feature/" + menu_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //GUEST CODE PAGE RELATED APIs

  // Get Page List
  getPages(filter = "") {
    return axios
      .get(API_URL + "gxp/hd-page" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add new Page
  addPage(data) {
    return axios
      .post(API_URL + "gxp/hd-page", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get Page details
  getPageDetails(page_id) {
    return axios
      .get(API_URL + "gxp/hd-page/" + page_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update Hotel Directory Page
  updatePage(page_id, data) {
    return axios
      .patch(API_URL + "gxp/hd-page/" + page_id + "/", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete Hotel Directory Page
  deletePage(page_id) {
    return axios
      .delete(API_URL + "gxp/hd-page/" + page_id + "/", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add Sub Page in Page
  addSubPages(page_id, sub_page_id, status) {
    return axios
      .post(
        API_URL +
          "gxp/hd-page/" +
          page_id +
          "/sub-page/" +
          sub_page_id +
          "/" +
          status,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Add Hotel Directory Page Image
  addPageImage(page_id, data) {
    return axios
      .post(API_URL + "gxp/hd-page/" + page_id + "/page-image", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update Hotel Directory Page Image
  updatePageImage(page_id, page_image_id, data) {
    return axios
      .patch(
        API_URL + "gxp/hd-page/" + page_id + "/page-image/" + page_image_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // delete Hotel Directory Page Image
  deletePageImage(page_id, page_image_id) {
    return axios
      .delete(
        API_URL + "gxp/hd-page/" + page_id + "/page-image/" + page_image_id,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // LIGHT BOX RELATED APIs

  // Get Light Box list
  getLightBox(filter = "") {
    return axios
      .get(API_URL + "gxp/light-box" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add New Light Box
  addLightBox(data) {
    return axios
      .post(API_URL + "gxp/light-box", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update Light Box
  updateLightBox(light_box_id, data) {
    return axios
      .patch(API_URL + "gxp/light-box/" + light_box_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete Light Box
  deleteLightBox(light_box_id) {
    return axios
      .delete(API_URL + "gxp/light-box/" + light_box_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // UNUSED FILEs

  // Page Bulk update
  updatePageInBulk(page_id, data) {
    return axios.post(
      API_URL + "gxp/hd-page/" + page_id + "/sub-page/bulk-update",
      data,
      { headers: authHeader() }
    );
  }
}
export default new GXPService();
